import { HiOutlineWrenchScrewdriver } from "react-icons/hi2";
import { RxLinkBreak2 } from "react-icons/rx";
import { TiHomeOutline } from "react-icons/ti";
import { SiInstatus, SiStagetimer } from "react-icons/si";
import { GiDeathZone, GiTreeRoots } from "react-icons/gi";
import { IoFastFoodOutline, IoPersonOutline } from "react-icons/io5";
import { BsCalendar3 } from "react-icons/bs";
import { MdPallet } from "react-icons/md";
import { GiBroom } from "react-icons/gi";

export const menuItemsDataWitron = [
  // ...
  {
    title: "Menu",
    url: "/",
    submenu: [
      {
        title: "Home",
        icon: <TiHomeOutline />,
        url: "/",
      },
      {
        title: "Dashboard",
        icon: <SiInstatus />,
        url: "/dashboard",
      },
      {
        title: "Lunch Menu",
        icon: <IoFastFoodOutline />,
        url: "/lunchmenu",
      },
      {
        title: "Active Faults",
        icon: <GiDeathZone />,
        submenu: [
          {
            title: "Area Overview",
            url: "/activefaults?page=area",
          },
          {
            title: "Edit Filters",
            url: "/activefaults?page=filterx",
          },
        ],
      },
      {
        title: "Yggdrasil",
        icon: <GiTreeRoots />,
        url: "/yggdrasil",
      },

      {
        title: "Machine Faults",
        icon: <RxLinkBreak2 />,
        url: "/machinefaults",
      },
      {
        title: "ShiftPlan",
        icon: <BsCalendar3 />,
        url: "/shiftplan",
      },
      {
        title: "Employees",
        icon: <IoPersonOutline />,
        url: "/employees",
      },
      {
        title: "Maintenance",
        icon: <HiOutlineWrenchScrewdriver />,
        submenu: [
          {
            title: "Statistics",
            url: "/maintenance?page=stats",
          },
          {
            title: "Detailed Statistics",
            url: "/maintenance?page=detailsStats",
          },
          {
            title: "Planned",
            url: "/maintenance?page=planned",
          },
          {
            title: "Planned ControlRoom",
            url: "/maintenance?page=plannedCR",
          },
          {
            title: "Snapshot Review",
            url: "/maintenance?page=snapReview",
          },
          {
            title: "Roadmap",
            url: "/maintenance?page=roadmap",
          },
          {
            title: "Site Services (Miljø)",
            icon: <GiBroom />,
            url: "/maintenance?page=siteServices",
          },
        ],
      },
      {
        title: "Depal",
        icon: <MdPallet />,
        url: "/machinefaults",
      },
    ],
  },
];

export const menuItemsDataCustomer = [
  // ...
  {
    title: "Menu",
    url: "/",
    submenu: [
      {
        title: "Home",
        icon: <TiHomeOutline />,
        url: "/",
      },
      {
        title: "Dasboard",
        icon: <SiInstatus />,
        url: "/dashboard",
      },
      {
        title: "Lunch Menu",
        icon: <IoFastFoodOutline />,
        url: "/lunchmenu",
      },
      {
        title: "Active Faults",
        icon: <GiDeathZone />,
        submenu: [
          {
            title: "Area Overview",
            url: "/activefaults?page=area",
          },
          {
            title: "Edit Filters",
            url: "/activefaults?page=filterx",
          },
        ],
      },
      {
        title: "Yggdrasil",
        icon: <GiTreeRoots />,
        url: "/yggdrasil",
      },
      {
        title: "Machine Faults",
        icon: <RxLinkBreak2 />,
        url: "/machinefaults",
      },

      {
        title: "Maintenance",
        icon: <HiOutlineWrenchScrewdriver />,
        submenu: [
          {
            title: "Statistics",
            url: "/maintenance?page=stats",
          },
          {
            title: "Planned",
            url: "/maintenance?page=planned",
          },
          {
            title: "Planned ControlRoom",
            url: "/maintenance?page=plannedCR",
          },
          {
            title: "Roadmap",
            url: "/maintenance?page=roadmap",
          },
          {
            title: "Site Services (Miljø)",
            icon: <GiBroom />,
            url: "/maintenance?page=siteServices",
          },
        ],
      },
      {
        title: "Depal",
        icon: <MdPallet />,
        url: "/machinefaults",
      },
    ],
  },
];

export const menuItemsData = [
  {
    title: "Menu",
    url: "/",
    submenu: [
      {
        title: "Home",
        icon: <TiHomeOutline />,
        url: "/",
      },
      {
        title: "Dashboard",
        icon: <SiInstatus />,
        url: "/dashboard",
        feature: "dashboard",
      },
      {
        title: "Machine Faults",
        icon: <RxLinkBreak2 />,
        url: "/machinefaults",
        feature: "machineFaults",
      },
      {
        title: "Lunch Menu",
        icon: <IoFastFoodOutline />,
        url: "/lunchmenu",
        feature: "lunchMenu",
      },
      {
        title: "Yggdrasil",
        icon: <GiTreeRoots />,
        url: "/yggdrasil",
        feature: "yggdrasil",
      },
      {
        title: "ShiftPlan",
        icon: <BsCalendar3 />,
        url: "/shiftplan",
        feature: "shiftPlan",
        companies: ["Witron"],
      },
      {
        title: "Employees",
        icon: <IoPersonOutline />,
        url: "/employees",
        feature: "employees",
        companies: ["Witron"],
        desktopOnly: true,
      },
      {
        title: "Maintenance",
        icon: <HiOutlineWrenchScrewdriver />,
        feature: "maintenance",
        submenu: [
          {
            title: "Statistics",
            url: "/maintenance?page=stats",
          },
          {
            title: "Planned",
            url: "/maintenance?page=planned",
          },
          {
            title: "Planned ControlRoom",
            url: "/maintenance?page=plannedCR",
          },
          {
            title: "Roadmap",
            url: "/maintenance?page=roadmap",
          },
          {
            title: "Site Services (Miljø)",
            icon: <GiBroom />,
            url: "/maintenance?page=siteServices",
          },
        ],
      },
      {
        title: "Active Faults",
        icon: <GiDeathZone />,
        feature: "activeFaults",
        submenu: [
          {
            title: "Area Overview",
            url: "/activefaults?page=area",
          },
          {
            title: "Edit Filters",
            url: "/activefaults?page=filterx",
          },
        ],
      },
    ],
  },
];